export default __webpack_public_path__ + "static/media/blue-arrow.2e7e7a83.gif";